import { api } from '../../../lib/api';
import { getProducts } from './get-products';

export const DELETE_PRODUCT_REQUEST = 'DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILED = 'DELETE_PRODUCT_FAILED';

export const DELETE_PRODUCT_MODAL_OPEN = 'DELETE_PRODUCT_MODAL_OPEN';
export const DELETE_PRODUCT_MODAL_CLOSE = 'DELETE_PRODUCT_MODAL_CLOSE';

export const deleteProduct = function (productId, onDelete) {
  return function (dispatch) {
    dispatch({
      type: DELETE_PRODUCT_REQUEST
    })
    api.deleteProduct(productId).then(deleteProductResponse => {
      dispatch({
        type: DELETE_PRODUCT_SUCCESS,
        payload: deleteProductResponse
      })
      if (onDelete) onDelete()
    }).catch(error => {
      dispatch({
        type: DELETE_PRODUCT_FAILED,
        error
      });

      dispatch(getProducts());
    })
  }
}

export const openDeleteProductModal = function(productId) {
  return function(dispatch) {
    dispatch({
      type: DELETE_PRODUCT_MODAL_OPEN,
      payload: {
        toDeleteProductId: productId,
        confirmDeleteModalOpen: true
      }
    })
  }
}

export const closeDeleteProductModal = function() {
  return function(dispatch) {
    dispatch({
      type: DELETE_PRODUCT_MODAL_CLOSE,
      payload: {
        toDeleteProductId: null,
        confirmDeleteModalOpen: false
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/delete-product.js